import React, {useState, useContext, createContext} from "react";
import axiosInstance from "./axiosApi";
// import {startLoader, stopLoader} from "../../components/Progress/Progress"

const authContext = createContext();
// Provider component that wraps your app and makes auth object ...
// ... available to any child component that calls useAuth().
export function ProvideAuth({children}) {
  const auth = useProvideAuth();
  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = () => {
  return useContext(authContext);
};

// Provider hook that creates auth object and handles state
function useProvideAuth() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(false);

  // Wrap any Firebase methods we want to use making sure ...
  // ... to save the user to state.
  const signin = async (username, password) => {
    try {
      setError(false)
      setUser(null);

      let response = await axiosInstance.post('token/obtain/', {
        username: username,
        password: password
      });

      axiosInstance.defaults.headers['Authorization'] = "Bearer " + response.data.access;
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      setUser(true)
      return true
    } catch (error) {
      setError(true)
    }
    return false
  };
  const signup = async (username, email, password) => {
    try {
      setError(false);
      setUser(null);

      let response = await axiosInstance.post('register/', {
        username,
        email,
        password,
      });

      axiosInstance.defaults.headers['Authorization'] = "Bearer " + response.data.access;
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      setUser(true);
      return { success: true };
    } catch (error) {
      setError(true);
      const errors = error?.response?.data?.errors || {};
      return { success: false, errors };
    }
  };
  const signout = async () => {
    try {
      const response = await axiosInstance.post('/blacklist/', {
        "refresh_token": localStorage.getItem("refresh_token")
      });
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      axiosInstance.defaults.headers['Authorization'] = null;
    } catch (e) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      axiosInstance.defaults.headers['Authorization'] = null;
    }
  };
  const sendPasswordResetEmail = async (identifier) => {
    try {
      // Explicitly drop any (possibly stale) auth header — this endpoint is anonymous.
      // `identifier` is a username, email, or phone; backend texts the reset link.
      await axiosInstance.post('password-reset/request/', {identifier}, {headers: {'Authorization': null}});
      return {success: true};
    } catch (error) {
      const detail = error?.response?.data?.detail;
      return {success: false, error: detail || 'Something went wrong. Please try again.'};
    }
  };
  const confirmPasswordReset = async (uid, token, password) => {
    try {
      await axiosInstance.post('password-reset/confirm/', {uid, token, password}, {headers: {'Authorization': null}});
      return {success: true};
    } catch (error) {
      const data = error?.response?.data || {};
      return {success: false, error: data.error || 'Something went wrong. Please try again.'};
    }
  };

  const isLoggedIn = async () => {
    try {
      let response = await axiosInstance.post('token/verify/');
      if (response && response.data && response.data.success) {
        setUser(true);
        return true;
      }
    } catch {
    }
    setUser(false);
    return false;
  }

  // Return the user object and auth methods
  return {
    user,
    setUser,
    signin,
    signup,
    signout,
    sendPasswordResetEmail,
    confirmPasswordReset,
    error,
    isLoggedIn,
  };
}